"use strict";

var _defineProperty = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ApprovalPMRowsDataDTO_1 = require("../../report/model/ApprovalPMRowsDataDTO");

var ApprovalPMRowsDataDTOConverter_1 = require("./ApprovalPMRowsDataDTOConverter");

var ApprovalReportPMRowDTOConverter_1 = require("./ApprovalReportPMRowDTOConverter");

var ApprovalPMRowsDataDTOConverterImpl =
/*#__PURE__*/
function (_ApprovalPMRowsDataDT) {
  _inherits(ApprovalPMRowsDataDTOConverterImpl, _ApprovalPMRowsDataDT);

  function ApprovalPMRowsDataDTOConverterImpl(approvalReportPMRowDTOConverter) {
    var _this;

    _classCallCheck(this, ApprovalPMRowsDataDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ApprovalPMRowsDataDTOConverterImpl).call(this));
    _this.approvalReportPMRowDTOConverter = approvalReportPMRowDTOConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ApprovalPMRowsDataDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new ApprovalPMRowsDataDTO_1.ApprovalPMRowsDataDTO(conversions.asObject(source, 'rows', function (o) {
        return Object.keys(o).reduce(function (acc, cur) {
          return Object.assign(acc, _defineProperty({}, cur, _this2.approvalReportPMRowDTOConverter.toObject(source.rows[cur], conversions)));
        }, {});
      }), source.totalRowCount, source.expandedGroups ? conversions.asObjectSet(source, 'expandedGroups', function (d) {
        return d;
      }) : undefined);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        totalRowCount: source.totalRowCount,
        rows: Object.keys(source.rows).reduce(function (acc, cur) {
          return Object.assign(acc, _defineProperty({}, cur, _this3.approvalReportPMRowDTOConverter.toDocument(source.rows[cur], conversions)));
        }, {}),
        expandedGroups: source.expandedGroups ? conversions.asObjectArray(source, 'expandedGroups', function (c) {
          return c;
        }) : undefined
      });
      return result;
    }
  }]);

  return ApprovalPMRowsDataDTOConverterImpl;
}(ApprovalPMRowsDataDTOConverter_1.ApprovalPMRowsDataDTOConverter);

ApprovalPMRowsDataDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ApprovalReportPMRowDTOConverter_1.ApprovalReportPMRowDTOConverter])], ApprovalPMRowsDataDTOConverterImpl);
exports.ApprovalPMRowsDataDTOConverterImpl = ApprovalPMRowsDataDTOConverterImpl;